import lodash from 'lodash';
const { camelCase } = lodash;
// This horrible thing is to avoid a problem where the filters/index.js causes circular
// dependencies.
// Essentially, it provides a layer of indirection so that Node can finish loading all
// the modules without running into anything circular.
let _filters = {};
export default function getFilter(bbFilterType) {
    return _filters[camelCase(bbFilterType)];
}
export function popForTests(filters) {
    _filters = filters;
}
// Make test setup available outside lib_ui-services
getFilter.popForTests = popForTests;

export let loading;

if (!globalThis.__UNIT_TESTING__) {
    setTimeout(async () => {
        // avoid warning for dynamic import (which seems to need the extension)
        // eslint-disable-next-line import/extensions
        loading = import('./filters/index.js');
        _filters = await loading;
    }, 1);
}
